<div
  *ngIf="[contextService.resAsync | async, queryData$ | async, persistData$ | async]"
  [ngClass]="{ 'user-settings-body': true }"
  [ngStyle]="{ width: allowUserNameChange ? '' : '286px' }"
>
  <div *ngIf="!errorMessage; else error">
    <dx-form [formData]="user" labelMode="floating" id="dxForm">
      <dxi-item *ngIf="allowUserNameChange" itemType="group" [caption]="res.get('UserSettings-MUser')">
        <dxi-item
          [cssClass]="getTextInputClass()"
          dataField="name"
          [editorOptions]="{ valueChangeEvent: 'input', disabled: isPending || isPasswordChanged }"
        >
          <dxo-label [text]="res.get('UserSettings-Name')"></dxo-label>
        </dxi-item>
        <dxi-item
          [cssClass]="getTextInputClass()"
          dataField="email"
          [editorOptions]="{ valueChangeEvent: 'input', disabled: isPending || isPasswordChanged }"
        >
          <dxo-label [text]="res.get('UserSettings-EMail')"></dxo-label>
        </dxi-item>
        <dxi-item
          [cssClass]="getTextInputClass()"
          dataField="login"
          [editorOptions]="{ readOnly: true, disabled: isPending || isPasswordChanged }"
        >
          <dxo-label [text]="res.get('UserSettings-Login')"></dxo-label>
        </dxi-item>
        <dxi-item itemType="empty"></dxi-item>
        <dxi-item
          [cssClass]="getSubmitButtonClass()"
          itemType="button"
          [buttonOptions]="{
            text: res.get('UserSettings-Save'),
            disabled: isPending || !isUserChanged || !isUserValid || isPasswordChanged,
            onClick: saveUser
          }"
        >
        </dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [caption]="getAuthenticationCaption()">
        <dxi-item
          [cssClass]="getTextInputClass()"
          dataField="password.currentPassword"
          [editorOptions]="{
            valueChangeEvent: 'input',
            mode: 'password',
            inputAttr: { autocomplete: 'new-password' },
            disabled: isPending || isUserChanged,
            buttons: currentPasswordTextBoxButton
          }"
        >
          <dxo-label [text]="res.get('UserSettings-CurrentPW')"></dxo-label>
        </dxi-item>
        <dxi-item
          [cssClass]="getTextInputClass()"
          dataField="password.newPassword"
          [editorOptions]="{
            valueChangeEvent: 'input',
            mode: 'password',
            inputAttr: { autocomplete: 'new-password' },
            disabled: isPending || isUserChanged,
            buttons: newPasswordTextBoxButton
          }"
        >
          <dxo-label [text]="res.get('UserSettings-NewPW')"></dxo-label>
        </dxi-item>
        <dxi-item
          [cssClass]="getTextInputClass()"
          dataField="password.confirmPassword"
          [editorOptions]="{
            valueChangeEvent: 'input',
            mode: 'password',
            inputAttr: { autocomplete: 'new-password' },
            disabled: isPending || isUserChanged,
            buttons: confirmPasswordTextBoxButton
          }"
        >
          <dxo-label [text]="res.get('UserSettings-ConfirmPW')"></dxo-label>
        </dxi-item>
        <dxi-item itemtype="empty">
          <ul class="passwordRequirementsList">
            <li class="req" *ngFor="let req of passwordRequirementsArray">{{ req }}</li>
          </ul>
        </dxi-item>
        <dxi-item
          [cssClass]="getSubmitButtonClass()"
          itemType="button"
          [buttonOptions]="{
            text: res.get('UserSettings-ChangePassword'),
            disabled: isPending || !isPasswordValid || isUserChanged,
            onClick: changePassword
          }"
        >
        </dxi-item>
        <dxi-item
          *ngIf="!allowUserNameChange"
          [cssClass]="getCancelButtonClass()"
          itemType="button"
          [buttonOptions]="{
            text: res.get('UserSettings-Cancel'),
            onClick: cancelPasswordChange
          }"
        >
        </dxi-item>
      </dxi-item>
    </dx-form>
  </div>
  <ng-template #error>
    <div>{{ errorMessage }}</div>
  </ng-template>
</div>
